import { useDispatch, useSelector } from "react-redux";
import ReportFilters from "./filters";
import ReportUserList from "./reportUserList";
import { useEffect, useState, useRef } from "react";
import {
    getAllUserReportList,
    resetTableData,
} from "./store/finalReports.slice";
import EditReport from "../reports/reportsTimeSheet/EditReport";
import { Modal } from "antd";

const FinalReports = () => {
    const dispatch = useDispatch();
    const tableData = useSelector(
        (state) => state.finalReportsSlice.tableData
    );
    const [showWorkReport, setShowWorkReport] = useState(false);
    const modalOpenRef = useRef(false); // ✅ track if modal is open

    useEffect(() => {
        dispatch(resetTableData());
    }, [dispatch]);

    useEffect(() => {
        const cleanedData = {
            ...tableData,
            projectId:
                Array.isArray(tableData.projectId) &&
                    tableData.projectId.length > 0 &&
                    tableData.projectId[0] !== undefined
                    ? [tableData.projectId[0]?.value]
                    : undefined,
        };
        if (tableData.start || tableData.end) {
            dispatch(getAllUserReportList(cleanedData));
        }
    }, [
        tableData?.page,
        tableData?.limit,
        tableData?.userId,
        tableData?.dateType,
        tableData?.end,
        tableData?.projectId,
        dispatch,
    ]);

    // wrapper function for both UI & browser back
    const confirmClose = (onConfirm) => {
        if (modalOpenRef.current) return; // prevent multiple modals
        modalOpenRef.current = true;

        Modal.confirm({
            title: (
                <span style={{ fontFamily: '"Nunito Sans", sans-serif', fontWeight: 600 }}>
                    Discard Changes?
                </span>
            ),
            content: (
                <span style={{ fontFamily: '"Nunito Sans", sans-serif' }}>
                    You have unsaved changes in this report.
                    If you go back now, all your edits will be lost.
                    Are you sure you want to continue?
                </span>
            ),
            okText: "Yes, discard",
            cancelText: "No, stay",
            okButtonProps: { style: { backgroundColor: "#4F46E5", borderColor: "#4F46E5", color: "#fff" } }, // red
            cancelButtonProps: { style: { color: "#000000ff", borderColor: "#4F46E5" } }, // blue text
            onOk: () => {
                modalOpenRef.current = false;
                if (onConfirm) onConfirm();
            },
            onCancel: () => {
                modalOpenRef.current = false;
                if (showWorkReport) {
                    window.history.pushState(null, "");
                }
            },
        });
    };


    useEffect(() => {
        if (!showWorkReport) return;

        const handlePopState = (event) => {
            event.preventDefault();
            confirmClose(() => {
                setShowWorkReport(false);
            });
        };

        // lock state
        window.history.pushState(null, "");
        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [showWorkReport]);

    return (
        <div>
            <div
                className="container"
                style={{
                    zIndex: 10,
                    minHeight: "100vh",
                    padding: "35px",
                    borderRadius: "0px",
                }}
            >
                {!showWorkReport && (
                    <>
                        <ReportFilters
                            name={"timeSheet"}
                            setShowWorkReport={setShowWorkReport}
                            showWorkReport={showWorkReport}
                        />
                        <ReportUserList />
                    </>
                )}

                {showWorkReport && (
                    <EditReport
                        setShowWorkReport={() =>
                            confirmClose(() => setShowWorkReport(false))
                        }
                    />
                )}
            </div>
        </div>
    );
};

export default FinalReports;
